
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Physical_Activity_Schedule_for_People_with_Diabetes",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Physical_Activity_Schedule_for_People_with_Diabetes.vue